// src/layouts/StudentLayout.jsx - Unified responsive layout for student
import { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../services/firebase';
import UnifiedSidebar from '../components/unified/UnifiedSidebar';
import UnifiedNavbar from '../components/unified/UnifiedNavbar';

export default function StudentLayout({ user, onLogout }) {
  const [isMobile, setIsMobile] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const navigate = useNavigate();

  // Detect screen size for responsive behavior
  useEffect(() => {
    const checkScreenSize = () => {
      const mobile = window.innerWidth < 1024; // Simple mobile detection
      setIsMobile(mobile);

      // Auto-open/close sidebar based on screen size
      if (!mobile) {
        setSidebarOpen(true); // Open on desktop/tablet
      } else {
        setSidebarOpen(false); // Closed on mobile
      }
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      onLogout();
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex relative">
      {/* Sidebar for desktop or mobile when toggled */}
      {(!isMobile || sidebarOpen) && (
        <UnifiedSidebar
          user={user}
          isOpen={sidebarOpen}
          setIsOpen={setSidebarOpen}
          isMobile={isMobile}
          role="student"
        />
      )}

      {/* Mobile overlay when sidebar is open */}
      {isMobile && sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Main content area */}
      <div className={`flex-1 transition-all duration-300 ml-0`}>
        {/* Top navbar for all screen sizes */}
        <UnifiedNavbar
          user={user}
          onLogout={handleLogout}
          isMobile={isMobile}
          onMenuToggle={() => setSidebarOpen(!sidebarOpen)}
          sidebarOpen={sidebarOpen}
        />

        {/* Page content with top padding to account for fixed navbar */}
        <main className="min-h-screen pt-20 lg:px-0 px-4">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
